import { Box, Button } from "@mui/material";
import React from "react";
import { toggleButtonContainerStyle, buttonStyle } from "./ToggleButton.styles";

interface IToggleButton {
  handleOnClick: (value: string) => void,
  selectedButton: string,
  buttonList: {
    displayText: string,
    value: string,
  }[],
}

const ToggleButton: React.FC<IToggleButton> = (props) => {
  const { handleOnClick, selectedButton, buttonList } = props;

  return (
    <Box
      sx={toggleButtonContainerStyle}>
      {
        buttonList.map((button, index) => {
          return <Button
            key={index}
            onClick={() => handleOnClick(button.value)}
            sx={{ ...buttonStyle }}
            className={`!normal-case !text-black ${selectedButton === button.value ? "!bg-white !font-bold" :
              "!bg-transparent"}`}
          >
            {button.displayText}
          </Button>;
        })
      }
    </Box>
  );
};

export default ToggleButton;
